const WASM_BASE =
  (process.env.VITE_STOP_WASM_BASE ?? '/wasm/stop').replace(/\/$/, '');

type StopAesGcmDecryptFn = (
  packedBase64: string,
  keyBase64: string
) => Promise<string>;

interface StopCryptoGlobal {
  __stopAesGcmDecrypt?: StopAesGcmDecryptFn;
}

function stopCryptoGlobal(): StopCryptoGlobal {
  return globalThis as StopCryptoGlobal;
}

let cryptoHelperLoaded = false;

async function ensureStopCryptoHelper(): Promise<void> {
  const g = stopCryptoGlobal();
  if (cryptoHelperLoaded && g.__stopAesGcmDecrypt) return;
  await import(/* webpackIgnore: true */ `${WASM_BASE}/stop-crypto.js`);
  if (!stopCryptoGlobal().__stopAesGcmDecrypt) {
    throw new Error('Stop crypto helper failed to load.');
  }
  cryptoHelperLoaded = true;
}

export async function decryptStopBootstrapCipher(
  cipherBase64: string,
  keyBase64: string
): Promise<string> {
  await ensureStopCryptoHelper();
  const decrypt = stopCryptoGlobal().__stopAesGcmDecrypt;
  if (!decrypt) {
    throw new Error('Stop crypto helper failed to load.');
  }
  return decrypt(cipherBase64, keyBase64);
}
